import { useRoute, computed } from '@nuxtjs/composition-api';
import { useUser } from "@vsf-enterprise/sapcc";

const useAppState = () => {
  const route = useRoute();
  const { load: loadUser, logout, set: setUser } = useUser();

  const isLogout = computed(() => Boolean(route.value.query.logout));

  const loadInitialAppState = async () => {
    await Promise.all([loadUser()]);
  };

  const resetAppState = async () => {
    await resetUser();
  };

  async function resetUser() {
    setUser(null);
    await logout();
  }

  return { loadInitialAppState, resetAppState, isLogout };
};

export default useAppState;
